import axios from '@/utils/request'
var Qs = require('qs')

export default {
	// 2021-09-17
	search(params) {
		return axios.get('/weddingDressHall/product', params)
	},
	// 2022-01-24
	findAllService() {
		return axios.get('/weddingDressHall/product/find-all-service')
	},

	// 2021-09-17
	delete(id) {
		return axios.delete('/weddingDressHall/product/' + id)
	},
	// 2021-09-17
	batchDelete(params) {
		return axios.put('/weddingDressHall/product/batch-delete', params)
	},
	// 2021-09-17
	create(params) {
		return axios.post('/weddingDressHall/product', params)
	},
	// 2021-09-23
	insertAndInitInv(params) {
		return axios.post('/weddingDressHall/product/insert-and-init-inv', params)
	},
	// 2021-09-17
	update(id, params) {
		return axios.put('/weddingDressHall/product/' + id, params)
	},
	// 2021-09-17
	findByProductNo(params) {
		return axios.get('/weddingDressHall/product/find-by-product-no', params)
	},
	// 2021-09-19
	vagueFindByProductNo(params) {
		return axios.get('/weddingDressHall/product/vague-find-by-product-no', params)
	},
	// 2021-02-03
	//   vagueFindByProductNoAll(params) {
	//     return axios.get('/weddingDressHall/product/vague-find-by-product-no-all', params)
	//   },
	// 2021-09-18
	exportExcel(params) {
		return axios.get('/weddingDressHall/product/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},

	// 2021-09-18
	copy(id, params) {
		return axios.put('/weddingDressHall/product/' + id + '/copy', params)
	},
	// 2021-09-18
	repeatCount() {
		return axios.get('/weddingDressHall/product/repeat-count')
	},
	// 2021-09-18
	findById(id) {
		return axios.get('/weddingDressHall/product/' + id)
	},
	//======================
	//   // 2020-08-18
	//   productSuppliersfindById(id) {
	//     return axios.get('/weddingDressHall/product/' + id + '/suppliers')
	//   },
	// 2021-10-20
	createProductSupplier(params) {
		return axios.post('/weddingDressHall/product/supplier/insert-batch', params)
	},
	// 2021-10-20
	updateProductSupplier(productSupplierId, params) {
		return axios.put('/weddingDressHall/product/supplier/' + productSupplierId, params)
	},
	//2021-10-20
	deleteProductSupplier(productSupplierId) {
		return axios.delete('/weddingDressHall/product/supplier/' + productSupplierId)
	},
	// 2021-10-20
	updateDefaultSupplier(productSupplierId) {
		return axios.put('/weddingDressHall/product/supplier/' + productSupplierId + '/update-default-supplier')
	},
	//========

}

